import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=53a97aab&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"
import style0 from "../../../../assets/css/menu.scss?vue&type=style&index=0&id=53a97aab&prod&lang=scss&scoped=true&external"
import style1 from "./menu.vue?vue&type=style&index=1&id=53a97aab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a97aab",
  null
  
)

export default component.exports